export enum TaxVat {
    WITHOUT_VAT = 'WITHOUT_VAT',
    WITH_VAT = 'WITH_VAT'
}
